import { fromJS } from "immutable"

import {
  GET_REPORTS_DASHBOARD_DATA_WATCHER,
  GET_REPORTS_DASHBOARD_DATA_SUCCESS,
  GET_REPORTS_DASHBOARD_DATA_FAILED,
  GET_DIVISIONS_AMBASSADOR_WATCHER,
  GET_DIVISIONS_AMBASSADOR_FAILED,
  GET_DIVISIONS_AMBASSADOR_SUCCESS,
  GET_SELECTED_DIVISION_WATCHER,
  GET_SELECTED_DIVISION_FAILED,
  GET_SELECTED_DIVISION_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  dashboardData: {},
  isLoadingDashboardData: true,
  ambassadorDivisions: [],
  selectedDivision: undefined,
})

function reportsDashboardReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SELECTED_DIVISION_WATCHER:
      return state
        .set("isLoadingDashboardData", true)
        .set("selectedDivision", undefined)
    case GET_SELECTED_DIVISION_SUCCESS:
      return state
        .set("isLoadingDashboardData", false)
        .set("selectedDivision", action.payload)
    case GET_SELECTED_DIVISION_FAILED:
      return state
        .set("isLoadingDashboardData", false)
        .set("selectedDivision", null)
    case GET_DIVISIONS_AMBASSADOR_WATCHER:
      return state
        .set("isLoadingDashboardData", true)
        .set("ambassadorDivisions", [])
    case GET_DIVISIONS_AMBASSADOR_SUCCESS:
      return state
        .set("isLoadingDashboardData", false)
        .set("ambassadorDivisions", action.payload)
        .set(
          "selectedDivision",
          action.payload.length > 0 && action.payload[0].id_division
        )
    case GET_DIVISIONS_AMBASSADOR_FAILED:
      return state
        .set("isLoadingDashboardData", false)
        .set("ambassadorDivisions", [])
    case GET_REPORTS_DASHBOARD_DATA_WATCHER:
      return state.set("isLoadingDashboardData", true).set("dashboardData", {})
    case GET_REPORTS_DASHBOARD_DATA_SUCCESS:
      return state
        .set("isLoadingDashboardData", false)
        .set("dashboardData", action.payload)
    case GET_REPORTS_DASHBOARD_DATA_FAILED:
      return state.set("isLoadingDashboardData", false).set("dashboardData", {})
    default:
      return state
  }
}

export default reportsDashboardReducer
